import { memo } from 'react';
import Script from 'next/script';
import { AnalyticsPixelId } from 'core/analytics/entities';
import { AxonScriptsService } from 'core/analytics/services';
import { CustomAppEvents } from 'core/common/entities';
import { areArraysOfPrimitivesEqual } from 'core/common/utils/areArraysOfPrimitivesEqual';
import { prepareHtml } from 'core/common/utils/prepareHtml';

type AxonScriptsProps = {
  ids: Array<AnalyticsPixelId>;
};

const AxonScripts = ({ ids }: AxonScriptsProps) => {
  return (
    <>
      {ids.map((id: string) => {
        return (
          <Script
            id={`axon-pixel-${id}`}
            key={`axon-pixel-${id}`}
            strategy="afterInteractive"
            dangerouslySetInnerHTML={prepareHtml(AxonScriptsService.getPixelCode(id))}
            onReady={() => {
              try {
                const event = new Event(CustomAppEvents.AXON_LOADED);
                document.dispatchEvent(event);
              } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error dispatching Axon loaded event', error);
              }
            }}
          />
        );
      })}
    </>
  );
};

export default memo(AxonScripts, (prevProps, nextProps) =>
  areArraysOfPrimitivesEqual(prevProps.ids, nextProps.ids),
);
